import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 8,
			fill: "#FF4E4E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 8,
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.31445,
			y: 3.76465,
			width: 1.82857,
			height: 5.64706,
			rx: .914286,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.31445,
			y: 10.353,
			width: 1.82857,
			height: 1.88235,
			rx: .914286,
			fill: "white"
		})
	]
});
export default SvgStatusError;
